module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "wrapper",
    class: {
      withBorder: _vm.full
    }
  }, [(_vm.forecastsByItem.length) ? _c('section', [(_vm.full) ? _c('h1', {
    staticClass: "title"
  }, [_vm._v("Forecast")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      row: _vm.full
    }
  }, [(_vm.full) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "selector"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v("select a forecast")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.forecastsByItem), function(forecast) {
    return _c('div', {
      key: forecast.id,
      staticClass: "item",
      class: {
        selected: _vm.selectedForecast && _vm.selectedForecast.id === forecast.id
      },
      on: {
        "click": function($event) {
          _vm.selectForecast(forecast)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(forecast.reference) + " - " + _vm._s(forecast.name) + "\n                        ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'col-lg-10': _vm.full
    }
  }, [(_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedForecast && this.forecastWindows) ? _c('ForecastTable', [_c('template', {
    slot: "head-row-0"
  }, [_c('th', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "colspan": _vm.selectedForecast.recurrenceAmount + 2 + (_vm.hasPreseries ? 1 : 0)
    }
  }, [_c('ForecastNameBanner', {
    attrs: {
      "forecast": _vm.selectedForecast
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), (_vm.hasPreseries) ? _c('td', {
    staticClass: "preseries-header"
  }, [_c('span', [_vm._v("\n                                        " + _vm._s(_vm.getDateByFormat(_vm.selectedForecast.preseriesDate, "MM")) + " "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.getDateByFormat(_vm.selectedForecast.preseriesDate, "YYYY")) + " "), _c('br'), _vm._v("\n                                        PRESERIES\n                                    ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedForecastInfos.recurrenceAmount), function(recurrence) {
    return _c('td', {
      key: ("rep_amount_" + recurrence)
    }, [(_vm.selectedForecastInfos.datesRecurrence.length) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm.getDateByFormat(_vm.selectedForecastInfos.datesRecurrence[recurrence - 1], "MM")) + " "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.getDateByFormat(_vm.selectedForecastInfos.datesRecurrence[recurrence - 1], "YYYY")) + "\n                                    ")]) : _vm._e()])
  })], 2), _vm._v(" "), _vm._l((_vm.forecastWindows), function(forecastWindow, index) {
    return _c('tr', {
      key: forecastWindow.id,
      class: {
        odd: index % 2 === 0
      }
    }, [_c('td', {
      staticClass: "zoneName"
    }, [_vm._v(_vm._s(forecastWindow.zone.name))]), _vm._v(" "), (_vm.hasPreseries) ? _c('td', {
      staticClass: "preseries-cell"
    }, [_vm._v("\n                                    " + _vm._s(_vm.preseriesQuantityForWindow(forecastWindow)) + "\n                                ")]) : _vm._e(), _vm._v(" "), _vm._l((forecastWindow.quantities.filter(function (q) { return !q.isPreseries && q.recurrence > 0; })), function(quantity, qIndex) {
      return (quantity.item === _vm.itemId) ? _c('td', {
        key: ((forecastWindow.id) + "_" + qIndex)
      }, [_vm._v("\n                                    " + _vm._s(quantity.quantity || 0) + "\n                                ")]) : _vm._e()
    }), _vm._v(" "), _c('td', {
      staticClass: "zoneTotal"
    }, [_vm._v(_vm._s(_vm.amountPerForecastWindow(forecastWindow)))])], 2)
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), (_vm.hasPreseries) ? _c('td', {
    staticClass: "preseries-cell total"
  }, [_vm._v("\n                                    " + _vm._s(_vm.totalPreseries) + "\n                                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedForecast.recurrenceAmount), function(recurrence) {
    return _c('td', {
      key: ("recurrence-cal-" + recurrence)
    }, [_vm._v("\n                                    " + _vm._s(_vm.amountPerRecurrence(recurrence)) + "\n                                ")])
  }), _vm._v(" "), _c('td', {
    staticClass: "total"
  }, [_vm._v("Total: " + _vm._s(_vm.totalAmount))])], 2)], 2)])], 2) : _vm._e()], 1)])]) : _c('section', [_vm._v("No associated forecasts")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b4338c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/catalogue/ItemQuantities.vue
// module id = 3095
// module chunks = 0